"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var CatalogSelectorDropdownCountsQueryGql_1 = require("../../queries/CatalogSelectorDropdownCountsQueryGql");
var renderQueryResult_1 = require("../renderQueryResult");
var CatalogBrowserCountsQueryWrapper = /** @class */ (function (_super) {
    __extends(CatalogBrowserCountsQueryWrapper, _super);
    function CatalogBrowserCountsQueryWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderWebClientResponse = function (response) {
            if (response.type === 'SUCCESS') {
                return _this.props.children({
                    databasesCount: response.databasesCount,
                    tablesCount: response.tablesCount,
                });
            }
            else {
                return _this.props.children({
                    databasesCount: null,
                    tablesCount: null
                });
            }
        };
        _this.renderChildrenWithEmptyCounts = function () {
            return _this.props.featureFlags.externalAssetsWithCRASSEnabled && _this.props.webClientResult ?
                _this.renderWebClientResponse(_this.props.webClientResult) :
                _this.props.children({
                    databasesCount: null,
                    tablesCount: null,
                });
        };
        _this.renderChildrenWithData = function (data) {
            return _this.props.featureFlags.externalAssetsWithCRASSEnabled && _this.props.webClientResult ?
                _this.renderWebClientResponse(_this.props.webClientResult) :
                _this.props.children({
                    databasesCount: data.databasesConnection
                        ? data.databasesConnection.totalCount
                        : null,
                    tablesCount: data.databaseTablesConnection
                        ? data.databaseTablesConnection.totalCount
                        : null,
                });
        };
        _this.renderNoData = function () {
            return _this.props.featureFlags.externalAssetsWithCRASSEnabled && _this.props.webClientResult ?
                _this.renderWebClientResponse(_this.props.webClientResult) :
                (React.createElement(React.Fragment, null,
                    data_catalog_shared_1.reportNoData(),
                    _this.renderChildrenWithEmptyCounts()));
        };
        _this.renderDataWithError = function (data, errorCode) {
            return (React.createElement(React.Fragment, null,
                data_catalog_shared_1.reportGraphQLError(errorCode),
                _this.props.featureFlags.externalAssetsWithCRASSEnabled && _this.props.webClientResult ?
                    _this.renderWebClientResponse(_this.props.webClientResult) :
                    _this.renderChildrenWithData(data)));
        };
        _this.renderError = function (errorCode) {
            return (React.createElement(React.Fragment, null,
                data_catalog_shared_1.reportGraphQLError(errorCode),
                _this.props.featureFlags.externalAssetsWithCRASSEnabled && _this.props.webClientResult ?
                    _this.renderWebClientResponse(_this.props.webClientResult) :
                    _this.renderChildrenWithEmptyCounts()));
        };
        return _this;
    }
    CatalogBrowserCountsQueryWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.Query, { query: CatalogSelectorDropdownCountsQueryGql_1.CatalogSelectorDropdownCountsQueryGql, variables: {
                textSearch: this.props.textSearch,
                hasActiveWarning: this.props.hasActiveWarning,
                isCertified: this.props.isCertified,
            } }, function (result) {
            return renderQueryResult_1.renderQueryResult(result, {
                renderLoading: _this.renderChildrenWithEmptyCounts,
                renderData: _this.renderChildrenWithData,
                renderNoData: _this.renderNoData,
                renderDataWithError: _this.renderDataWithError,
                renderError: _this.renderError,
            });
        }));
    };
    return CatalogBrowserCountsQueryWrapper;
}(React.Component));
exports.CatalogBrowserCountsQueryWrapper = CatalogBrowserCountsQueryWrapper;
//# sourceMappingURL=CatalogBrowserCountsQueryWrapper.js.map